var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
export function useCreateAssistantStream() {
    return (id, chatId, type) => __awaiter(this, void 0, void 0, function* () {
        const STREAM_URL = process.env.API_ENDPOINT_CHAT;
        const urlParams = new URLSearchParams();
        urlParams.append('chatId', chatId);
        urlParams.append('chatType', type);
        const url = `${STREAM_URL}/${id}?${urlParams.toString()}`;
        const source = new EventSource(url);
        return new Promise((resolve, reject) => {
            source.addEventListener('error', () => {
                source.close();
                reject(new Error('EventSource network error'));
            });
            source.addEventListener('open', () => {
                resolve(source);
            });
        });
    });
}
